/**
 * Slider Module
 * Handles posts carousel functionality
 */

function initPostsSlider() {
    const slider = document.getElementById('posts-slider');
    const prevBtn = document.getElementById('slider-prev');
    const nextBtn = document.getElementById('slider-next');
    const dotsContainer = document.getElementById('slider-dots');
    
    if (!slider || !prevBtn || !nextBtn) return;
    
    const slides = slider.querySelectorAll('[data-slide]');
    if (slides.length === 0) return;
    
    let currentIndex = 0;
    const totalSlides = slides.length;
    
    createDots(dotsContainer, totalSlides);
    
    function updateSlider(animated = true) {
        const offset = -(currentIndex * 100);
        slider.style.transition = animated ? 'transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
        slider.style.transform = `translateX(${offset}%)`;
        
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex >= totalSlides - 1;
        
        updateDots(dotsContainer, currentIndex);
    }
    
    function goToSlide(slideIndex) {
        currentIndex = Math.max(0, Math.min(slideIndex, totalSlides - 1));
        updateSlider();
    }
    
    function nextSlide() {
        if (currentIndex < totalSlides - 1) {
            currentIndex++;
            updateSlider();
        }
    }
    
    function prevSlide() {
        if (currentIndex > 0) {
            currentIndex--;
            updateSlider();
        }
    }
    
    prevBtn.addEventListener('click', prevSlide);
    nextBtn.addEventListener('click', nextSlide);
    
    initTouchSupport(slider, nextSlide, prevSlide);
    initKeyboardNavigation(nextSlide, prevSlide);
    
    const dots = dotsContainer.querySelectorAll('button');
    dots.forEach((dot, i) => dot.addEventListener('click', () => goToSlide(i)));
    
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => updateSlider(false), 250);
    });
    
    updateSlider(false);
}

function createDots(container, count) {
    for (let i = 0; i < count; i++) {
        const dot = document.createElement('button');
        dot.className = 'transition-all duration-500 rounded-full';
        dot.style.width = i === 0 ? '2.5rem' : '0.5rem';
        dot.style.height = '0.5rem';
        dot.style.backgroundColor = i === 0 ? 'var(--accent-color, #6366f1)' : 'rgba(156, 163, 175, 0.5)';
        container.appendChild(dot);
    }
}

function updateDots(container, activeIndex) {
    const dots = container.querySelectorAll('button');
    dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.style.width = isActive ? '2.5rem' : '0.5rem';
        dot.style.backgroundColor = isActive ? 'var(--accent-color, #6366f1)' : 'rgba(156, 163, 175, 0.5)';
    });
}

function initTouchSupport(slider, nextSlide, prevSlide) {
    let touchStartX = 0;
    let touchEndX = 0;
    let isDragging = false;
    
    slider.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        isDragging = true;
    }, { passive: true });
    
    slider.addEventListener('touchmove', (e) => {
        if (isDragging) touchEndX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    slider.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        
        const swipeThreshold = 75;
        const diff = touchStartX - touchEndX;
        
        if (Math.abs(diff) > swipeThreshold) {
            diff > 0 ? nextSlide() : prevSlide();
        }
    }, { passive: true });
}

function initKeyboardNavigation(nextSlide, prevSlide) {
    document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            prevSlide();
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            nextSlide();
        }
    });
}
